<table mat-table [dataSource]="dataSource" multiTemplateDataRows>
  <ng-container  matColumnDef="nummer">
  <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'nummer' | translate}} </th>
  <td mat-cell class="projektnummerRow" (click)="toggle(element)" *matCellDef="let element">
    {{element['nummer']}}
  </td>
  </ng-container>
  <ng-container  matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'name' | translate}} </th>
    <td [class.kategorieText]="element['children'][0]?.name"  mat-cell (click)="toggle(element)" *matCellDef="let element">
      {{element['name']}}
    </td>
  </ng-container>
  <ng-container  matColumnDef="plz">
    <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'plz' | translate}} </th>
    <td mat-cell class="plzRow" (click)="toggle(element)" *matCellDef="let element">
      {{element['plz']}}
    </td>
  </ng-container>
  <ng-container  matColumnDef="ort">
    <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'ort' | translate}} </th>
    <td mat-cell class="ortRow" (click)="toggle(element)" *matCellDef="let element">
      {{element['ort']}}
    </td>
  </ng-container>
  <ng-container  matColumnDef="start">
    <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'start' | translate}} </th>
    <td mat-cell class="dateRow" (click)="toggle(element)" *matCellDef="let element">
      {{element['start']  | date:'dd.MM.yyyy'}}
    </td>
  </ng-container>
  <ng-container  matColumnDef="ende">
    <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'ende' | translate}} </th>
    <td mat-cell class="dateRow" (click)="toggle(element)" *matCellDef="let element">
      {{element['ende'] | date:'dd.MM.yyyy'}}
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element" class="actionRow">
      <button  class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button [disabled]="!showFunctions" *ngIf="element.aktiv==true" (click)="addProjektstufe.emit(element)"  mat-menu-item >{{ 'pages.projektverwaltung.actions.addStufe' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="element.aktiv==true" (click)="archiveProjekt.emit(element)"  mat-menu-item >{{ 'pages.projektverwaltung.actions.archiv' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="element.aktiv==false" (click)="dearchiveProjekt.emit(element)"  mat-menu-item >{{ 'pages.projektverwaltung.actions.dearchive' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="element.aktiv==true" (click)="editProjekt.emit(element)" mat-menu-item >{{ 'pages.projektverwaltung.actions.edit' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="element.aktiv==true && element['children'][0]?.name" (click)="copyProjektstufe(element)" mat-menu-item >{{ 'pages.projektverwaltung.actions.copy' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="copyNodes[0]?.id" (click)="pasteProjektstufe(element)" mat-menu-item >{{ 'pages.projektverwaltung.actions.paste' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="element.deletable==true && !element['children'][0]?.name" (click)="deleteProjekt.emit(element)" mat-menu-item >{{ 'pages.projektverwaltung.actions.delete' | translate }}</button>
      </mat-menu>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="AllColumnsToDisplay.length">
      <div
        [@detailExpand]="element?.id == arrOpen[element.level]?.id ? 'expanded' : 'collapsed'"
        [ngTemplateOutlet]="arrOpen[element.level]?.id != element?.id ? null : nextProjectLevel"
        [ngTemplateOutletContext]="{element:element}"
      >
      </div>
    </td>
  </ng-container>

  <tr class="header-table-row" mat-header-row *matHeaderRowDef="AllColumnsToDisplay; sticky: true;"></tr>
  <tr mat-row
      *matRowDef="let element; let index = dataIndex; columns: AllColumnsToDisplay;"
      class="example-element-row"
      [class.example-expanded-row]="!element['children'][0]?.name"
      [ngClass]="index % 2 == 0 ? 'evenRow' : 'oddRow'"
      >
  </tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>


<!-- Copyright 2019 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->

<ng-template #nextProjectLevel let-element='element'>
  <table class="inner-table" mat-table [dataSource]="element.children" multiTemplateDataRows>
    <ng-container  matColumnDef="nummer">
      <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'nummer' | translate}} </th>
      <td  mat-cell class="projektnummerRow" (click)="toggle(element)" *matCellDef="let element">
        {{element['nummer']}}
      </td>
    </ng-container>
    <ng-container  matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'name' | translate}} </th>
      <td [class.kategorieText]="element['children'][0]?.name" mat-cell (click)="toggle(element)" *matCellDef="let element">
        {{element['name']}}
      </td>
    </ng-container>
    <ng-container  matColumnDef="plz">
      <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'plz' | translate}} </th>
      <td mat-cell class="plzRow" (click)="toggle(element)" *matCellDef="let element">
        {{element['plz']}}
      </td>
    </ng-container>
    <ng-container  matColumnDef="ort">
      <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'ort' | translate}} </th>
      <td mat-cell class="ortRow" (click)="toggle(element)" *matCellDef="let element">
        {{element['ort']}}
      </td>
    </ng-container>
    <ng-container  matColumnDef="start">
      <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'start' | translate}} </th>
      <td mat-cell class="dateRow" (click)="toggle(element)" *matCellDef="let element">
        {{element['start']  | date:'dd.MM.yyyy'}}
      </td>
    </ng-container>
    <ng-container  matColumnDef="ende">
      <th mat-header-cell *matHeaderCellDef> {{'pages.projektverwaltung.table.' + 'ende' | translate}} </th>
      <td mat-cell class="dateRow" (click)="toggle(element)" *matCellDef="let element">
        {{element['ende'] | date:'dd.MM.yyyy'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let projekt"  class="actionRow">
        <button class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionMenu="matMenu">
          <button [disabled]="!showFunctions" *ngIf="projekt.aktiv==true" (click)="addProjektstufe.emit(projekt)"  mat-menu-item >{{ 'pages.projektverwaltung.actions.addStufe' | translate }}</button>
          <button [disabled]="!showFunctions" *ngIf="projekt.aktiv==true" (click)="editProjektstufe.emit(projekt)" mat-menu-item >{{ 'pages.projektverwaltung.actions.edit' | translate }}</button>
          <button [disabled]="!showFunctions" *ngIf="projekt.aktiv==true && projekt['children'][0]?.name" (click)="copyProjektstufe(projekt)" mat-menu-item >{{ 'pages.projektverwaltung.actions.copy' | translate }}</button>
          <button [disabled]="!showFunctions" *ngIf="copyNodes[0]?.id && projekt.aktiv==true" (click)="pasteProjektstufe(projekt)" mat-menu-item >{{ 'pages.projektverwaltung.actions.paste' | translate }}</button>
          <button [disabled]="!showFunctions" *ngIf="projekt.deletable==true && !projekt['children'][0]?.name" (click)="deleteProjekt.emit(projekt)" mat-menu-item >{{ 'pages.projektverwaltung.actions.delete' | translate }}</button>
          <button [disabled]="!showFunctions" *ngIf="projekt.aktiv==false && ( projekt.deletable==false || projekt['children'][0]?.name != undefined)"  mat-menu-item >Keine Funktionen verfügbar</button>

        </mat-menu>
      </td>
    </ng-container>


    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td class="expandedDetail" mat-cell *matCellDef="let element" [attr.colspan]="columnsUnterprojekt.length">
        <div

          [ngTemplateOutlet]="arrOpen[element.level]?.id != element?.id ? null : nextProjectLevel"
          [ngTemplateOutletContext]="{element:element}"
          class="example-element-detail"
          [@detailExpand]="element?.id == arrOpen[element.level]?.id ? 'expanded' : 'collapsed'">

        </div>
      </td>
    </ng-container>


    <tr mat-row *matRowDef="let element; let index = dataIndex; columns: columnsUnterprojekt;"
        class="example-element-row"
        [class.example-expanded-row]="element['children'][0]?.name == undefined"
        [ngClass]="index % 2 == 0 ? 'evenRow' : 'oddRow'"
        ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
</ng-template>

<!--  Die normale Reihe in der Tabelle und eine Datumsreihe ( da man dort mit der Datepipe unwandeln muss   -->
<ng-template #row let-element='element' let-column='column'>
  {{element[column]}}
</ng-template>
<ng-template #daterow let-element='element' let-column='column'>
  {{element[column] | date:'dd.MM.yyyy'}}
</ng-template>
